<div class="navigation-subitem" [class.disabled]="disabled()"
     [routerLink]="!disabled() ? link() : null" routerLinkActive="active"
     (click)="onClick()">
    <i class="far {{icon()}}" [title]="text()"></i> <div class="nav-label">{{text()}}</div>
</div>
